"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertCSS = void 0;
var prefix = 'dynamic-inserted-css-';
/**
 * insert css to the current page
 * */
function insertCSS(id, cssText) {
    var style;
    if (typeof document === 'object') {
        style = document.getElementById(prefix + id);
        if (!style) {
            style = document.createElement('style');
            style.id = prefix + id;
            // IE8/9 can not use document.head
            document.getElementsByTagName('head')[0].appendChild(style);
        }
        if (style.textContent !== cssText) {
            style.textContent = cssText;
        }
    }
    return style;
}
exports.insertCSS = insertCSS;
